
import React, { useEffect, useState, useRef, useCallback } from "react";
// import './menuiteams.css';
import Modal from 'react-modal';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import shadows from "@mui/material/styles/shadows";
import { FaInfoCircle } from "react-icons/fa";
import './Ordercart.css';
import { Link } from "react-router-dom";
import axios from 'axios';
import { FaPlus, FaMinus } from "react-icons/fa"; // For icons
import { useLocation } from "react-router-dom"; // ✅ Import useLocation


import { useParams } from "react-router-dom"; // If using React Router
import { Button } from "react-bootstrap";
// import Payments from "./Payments";
import Paymentdata from "./Paymentdata";
import { useLocation as useRouteLocation } from "react-router-dom";

const suggestions = [
    'kphb Manjeera Trinity 3rd gate straight line',

];
// const Ordercart = ({ orderId }) => {
const Cartwaiter = ({ filteredDataProp = [] }) => {


    const [serviceApplied, setServiceApplied] = useState(true); // initially applied

    const [cartId, setCartId] = useState(null); // if it’s React state
    const [cartData, setCartData] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);  // ✅ Initialize state
    const [selectedService, setSelectedService] = React.useState(null);

    const [showPopup, setShowPopup] = useState(false);

    const navigate = useNavigate();
    const [selectedOffers, setSelectedOffers] = useState([]);
    const [userId, setUserId] = useState(localStorage.getItem("userId") || 3); // Use stored userId or default 1
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderData, setOrderData] = useState(null);
    // const [cartItems, setCartItems] = useState([]);
    const { id } = useParams(); // Get ID from URL (if using routing)


    const [selectedOrderType, setSelectedOrderType] = useState(null);


    const [savedDetails, setSavedDetails] = useState(null);

    const [loading, setLoading] = useState(false);

    const [items, setItems] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [quantities, setQuantities] = useState({});

    const [isApplieds, setIsApplieds] = useState(false);
    const [coupons, setCoupons] = useState([]);
    const [activeCategory, setActiveCategory] = useState(null); // ✅ add this

    // 6% CGST & SGST
    // const [loading, setLoading] = useState(false);
    const [showPaymentData, setShowPaymentData] = useState(false);
    const [filteredData, setFilteredData] = useState(filteredDataProp);
    const [refresh, setRefresh] = useState(false);
    const [displayData, setDisplayData] = useState([]);
    const [availableBalance, setAvailableBalance] = useState(0);
    const [availableCompany, setAvailableCompany] = useState(0);
    const [availableSelf, setAvailableSelf] = useState(0);
    const [availableCashback, setAvailableCashback] = useState(0);

    const [appliedCoupon, setAppliedCoupon] = useState(null);

    const [isWalletChecked, setIsWalletChecked] = useState(false);
    const [isCashChecked, setIsCashChecked] = useState(false);
    const [isOnlineChecked, setIsOnlineChecked] = useState(false);


    const vendorId = Number(localStorage.getItem("vendorId") || 42);  // Ensure vendorId is a number

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

    const [isPaymentOptionsVisible, setIsPaymentOptionsVisible] = useState(false);
    const [isPayNowSelected, setIsPayNowSelected] = useState(false);


    const [isOrderReviewModalOpen, setIsOrderReviewModalOpen] = useState(false);

    const [discountApply, setDiscountApply] = useState("");
    const routeLocation = useRouteLocation(); // this holds routing info like state
    const [location, setLocation] = useState(""); // this is user-entered location
    const [landMark, setLandMark] = useState("");     // maps to "landMark"
    const [doorNo, setDoorNo] = useState("");         // part of "addressLine"
    const [streetNo, setStreetNo] = useState("");     // part of "addressLine"
    const [city, setCity] = useState("");             // maps to "city"
    const [stateVal, setStateVal] = useState("");     // maps to "state"
    const [pincode, setPincode] = useState("");       // maps to "pincode"
    const [addressDetails, setAddressDetails] = useState(null);
    const [showAddress, setShowAddress] = useState(false);
    const [category, setCategory] = useState(""); // This maps to "category"
    const [serviceCharges, setserviceCharges] = useState("");
    const [addresses, setAddresses] = useState([]);
    // const [selectedAddressId, setSelectedAddressId] = useState(null); // stores selected option from dropdown
    const [confirmedAddress, setConfirmedAddress] = useState(null);   // stores after Save button
    const [addressId, setAddressId] = useState(""); // Initialize with an empty string



    const [showWalletOptions, setShowWalletOptions] = useState(false);
    const [selectedWalletType, setSelectedWalletType] = useState("");

    const [selectedPayment, setSelectedPayment] = useState(""); // "online" or "cod"

    const [subTotal, setSubTotal] = useState(0);
    const [gstTotal, setgstTotal] = useState(0);
    const [cgst, setCgst] = useState(0);
    const [sgst, setSgst] = useState(0);
    const [platformCharge, setPlatformCharge] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [tableCode, settableCode] = useState(0);

    const [notes, setNotes] = useState({});
    const [orders, setOrders] = useState([]);

    const [gstData, setGstData] = useState(null);
    const [totals, setTotals] = useState({
        subTotal: 0,
        cgst: 0,
        sgst: 0,
        platformCharges: 0,
        grandTotal: 0
    });
    const [phoneNumber, setPhoneNumber] = useState("");

    const toggleServiceCharges = async (cartId) => {
        console.log("toggleServiceCharges called with cartId:", cartId);

        if (!cartId) {
            console.error("Cart ID is missing. Cannot apply service charges.");
            alert("Cart ID is missing");
            return;
        }

        const newStatus = serviceApplied ? "NOT_APPLICABLE" : "APPLICABLE";
        const token = localStorage.getItem("authToken");

        try {
            setLoading(true);

            // Update service charge on backend
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                {
                    id: 0,
                    serviceCharge: newStatus,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("✅ Service charge updated:", response.data);

            // Toggle local state
            setServiceApplied(!serviceApplied);

            // 🔹 Refresh cart data and recalculate totals immediately
            await loadCart(); // make sure loadCart sets cart items and quantities

            // Optionally, recalculate serviceCharges, subTotal, grandTotal here
            // Example:
            // setServiceCharges(newStatus === "APPLICABLE" ? calculatedServiceCharge : 0);
            // setSubTotal(...);
            // setGrandTotal(...);

        } catch (error) {
            console.error(
                "❌ Failed to update service charge:",
                error.response?.data || error.message
            );
            alert("Failed to update service charge. Try again.");
        } finally {
            setLoading(false);
        }
    };
    const containerHeight = window.innerWidth < 768
        ? '300px'      // Mobile
        : window.innerWidth < 850
            ? '300px'  // Below 850px
            : window.innerWidth < 1400
                ? '405px' // Between 850px and 1350px
                : '550px'; // Desktop
    const handleCheckoutClickS = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!userId) {
            alert("User ID not found. Please log in again.");
            return;
        }

        if (selectedPaymentMethod === "Maamaas_Wallet" && !selectedWalletType) {
            alert("Please select a wallet type before creating the order.");
            return;
        }

        try {
            localStorage.removeItem("orderId"); // Clear any previous order
            const storedCoupon = localStorage.getItem("appliedCoupon");
            const appliedCoupon = storedCoupon ? JSON.parse(storedCoupon) : null;

            // 🔹 ONLINE PAYMENT FLOW
            if (selectedPaymentMethod === "Online_Payment") {
                try {
                    const isRazorpayLoaded = await loadRazorpayScript();
                    if (!isRazorpayLoaded) {
                        alert("❌ Razorpay SDK failed to load.");
                        setLoading(false);
                        return;
                    }

                    const amountInPaise = Math.round(grandTotal * 100);
                    const displayAmount = amountInPaise / 100; // ₹130

                    console.log("💰 Final amount in paise:", amountInPaise);

                    // 🔹 Step 1: Create Razorpay Order via backend all the backed data of the api/paymnets/create-order not fetching in it 
                    const orderResponse = await fetch(
                        "https://backend.maamaas.com/food/api/payments/create-order",
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({
                                amount: displayAmount,
                                phoneNumber,
                                currency: "INR",
                                receipt: `order_${Date.now()}`,
                                notes: {
                                    customer_name: savedDetails?.name || "John Doe",
                                    order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
                                },
                            }),
                        }
                    );

                    if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
                    const orderData = await orderResponse.json();
                    console.log("📦 Razorpay Order Created:", orderData);

                    // 🔹 Step 2: Open Razorpay Checkout
                    const options = {
                        key: "rzp_live_RU5whSMu9rPV7s",
                        amount: amountInPaise,
                        currency: "INR",
                        order_id: orderData.orderId,
                        name: "Maamaa's House",
                        description: "Order Payment",
                        prefill: {
                            name: savedDetails?.name || "vamshi",
                            email: savedDetails?.email || "vamshikvky500@gmail.com",
                            contact: savedDetails?.mobileNumber || "9652030425",
                        },
                        theme: { color: "#3399cc" },

                        handler: async function (response) {
                            try {
                                console.log("✅ Payment Success Response:", response);

                                // 🔹 Capture payment payload
                                const capturePayload = {
                                    paymentId: response.razorpay_payment_id,
                                    amount: amountInPaise / 100,
                                    currency: "INR",
                                    receipt: `receipt_${Date.now()}`, // unique receipt
                                };

                                console.log("💾 Capture API Payload:", capturePayload);

                                // 🔹 Call capture API
                                const captureRes = await fetch(
                                    "https://backend.maamaas.com/food/api/payments/capture",
                                    {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: `Bearer ${token}`,
                                        },
                                        body: JSON.stringify(capturePayload),
                                    }
                                );

                                // 🔹 Parse capture response
                                const captureData = await captureRes.json();
                                console.log("💾 Capture API JSON response:", captureData);

                                if (!captureRes.ok || captureData.status !== "captured") {
                                    alert("❌ Payment capture failed!");
                                    return;
                                }

                                // 🔹 Backend order creation — send exact IDs
                                const backendOrderParams = {
                                    vendorId: vendorId,
                                    paymentMethod: "Online_Payment",
                                    razorpayPaymentId: response.razorpay_payment_id,
                                    razorpayOrderId: 1, // use captured order ID
                                    phoneNumber: savedDetails?.mobileNumber || "8688037081",
                                };

                                console.log("📝 Creating Backend Order with Params:", backendOrderParams);

                                const responseOrder = await axios.post(
                                    `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${localStorage.getItem(
                                        "cartId"
                                    )}`,
                                    "", // empty body
                                    {
                                        params: backendOrderParams,
                                        headers: { Authorization: `Bearer ${token}` },
                                        validateStatus: false,
                                    }
                                );

                                console.log("📝 Backend Order API Response Status:", responseOrder.status);
                                console.log("📝 Backend Order API Response Data:", responseOrder.data);

                                if (responseOrder.status === 200 || responseOrder.status === 201) {
                                    localStorage.setItem("orderId", responseOrder.data.orderId);
                                    // alert("✅ Payment captured and order placed successfully!");
                                    setShowPaymentData(true);
                                } else {
                                    console.error("❌ Order creation failed after payment!", responseOrder.data);
                                    alert("❌ Order creation failed after payment!");
                                }

                            } catch (err) {
                                console.error("❌ Error in payment handler:", err);
                                alert("❌ Something went wrong after payment.");
                            }
                        },


                    };

                    const paymentObject = new window.Razorpay(options);
                    paymentObject.open();
                    return;
                } catch (err) {
                    console.error("❌ Razorpay flow error:", err);
                    alert("❌ Razorpay flow failed.");
                    setLoading(false);
                    return;
                }
            }



            // 🔹 OTHER PAYMENT METHODS (COD / Wallet)
            const orderResponse = await axios.post(
                `https://backend.maamaas.com/food/api/orders/orders/vendor/create/${localStorage.getItem("cartId")}`,
                null,
                {
                    params: {
                        vendorId,
                        cartId: localStorage.getItem("cartId"),
                        paymentMethod: selectedPaymentMethod,
                        phoneNumber: "8688037081",
                        razorpayPaymentId: "N/A",
                        razorpayOrderId: "N/A",
                        couponCode: appliedCoupon?.code || "",
                        couponId: appliedCoupon?.id || null,
                    },
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            console.log("Order API Response:", orderResponse.data);

            if (orderResponse.status === 200 || orderResponse.status === 201) {
                // alert("✅ Order created successfully!");
                if (orderResponse.data && orderResponse.data.orderId) {
                    localStorage.setItem("orderId", orderResponse.data.orderId);
                }
                navigate("/foodaccount");
            } else {
                alert("⚠️ Failed to create order.");
            }
        } catch (error) {
            console.error("API error:", error);
            alert("Failed to proceed to checkout.");
        }
    };






    useEffect(() => {
        if (!vendorId) return; // ✅ Only check vendorId now

        const seatingId = localStorage.getItem("seatingId");
        const authToken = localStorage.getItem("authToken"); // ✅ Get token from localStorage

        axios
            .get(
                `https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`, // ✅ Send token in headers
                    },
                }
            )
            .then((res) => {
                if (res.data) {
                    const data = res.data;

                    // ✅ Save cartId in localStorage
                    if (data.cartId) {
                        localStorage.setItem("cartId", data.cartId);
                    }

                    setserviceCharges(data.serviceCharges || 0);
                    setgstTotal(data.gstTotal || 0);
                    setSubTotal(data.subtotal || 0);
                    setCgst((data.gstTotal || 0) / 2);
                    setSgst((data.gstTotal || 0) / 2);
                    setPlatformCharge(data.platformCharges || 0);
                    setGrandTotal(data.grandTotal || 0);
                    settableCode(data.tableCode || 0);
                }
            })
            .catch((err) => {
                console.error("Error fetching price details:", err);
            });
    }, [vendorId]); // ✅ Removed userId, only vendorId dependency








    //  const [isPaymentOptionsVisible, setIsPaymentOptionsVisible] = useState(false);
    const paymentRef = useRef(null);





    const handlePaymentClick = (type) => {
        setIsPayNowSelected(type === "payNow");
        setTimeout(() => {
            walletSectionRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
    };


    const paymentButtonsRef = useRef(null);
    const walletSectionRef = useRef(null);

    useEffect(() => {
        const flag = localStorage.getItem("showPaymentData") === "true";
        const service = localStorage.getItem("selectedService");
        const order = localStorage.getItem("orderData");

        if (flag && service && order) {
            setShowPaymentData(true);
            setSelectedService(service);
            setOrderData(JSON.parse(order));
        }

        // Optional: Clear after use
        localStorage.removeItem("showPaymentData");
        localStorage.removeItem("selectedService");
        localStorage.removeItem("orderData");
    }, []);
    useEffect(() => {
        const storedCoupon = JSON.parse(localStorage.getItem("couponData"));
        if (storedCoupon) {
            setAppliedCoupon(storedCoupon);
            setApplied(true);
        }
    }, []);


    React.useEffect(() => {
        const service = localStorage.getItem('selectedService');
        setSelectedService(service);
    }, []);
    // const cgst = 5;
    // const sgst = 5;

    const [billingData, setBillingData] = useState({});








    const [error, setError] = useState(null);


    const [walletData, setWalletData] = useState({

    });




    const handlePaymentClicks = (paymentType) => {
        if (paymentType === "payLater") {
            // Navigate to the DineInData component
            navigate("/dineindata"); // Assuming "/dinein" is the route for DineInData
        }
    };



    // handleCheckboxChange((all the category of the products and all ))

    const handleCheckboxChange = (e, method, type) => {
        const isChecked = e.target.checked;
        console.log(`Checkbox for ${method} is checked: `, isChecked);

        // Reset all payment type states first
        setIsWalletChecked(false);
        setIsCashChecked(false);
        setIsOnlineChecked(false);
        setShowWalletOptions(false);

        let newSelectedMethod = "";

        if (isChecked) {
            switch (method) {
                case "wallet":
                    setIsWalletChecked(true);
                    setShowWalletOptions(true); // Show wallet options
                    newSelectedMethod = "Maamaas_Wallet";
                    break;
                case "cash":
                    setIsCashChecked(true);
                    newSelectedMethod = "Cash";
                    break;
                case "online":
                    setIsOnlineChecked(true);
                    newSelectedMethod = "Online_Payment";
                    break;
                default:
                    break;
            }
            // ✅ Set selectedPayment to the passed type when checked
            setSelectedPayment(type);
        } else {
            // Unchecking resets selectedPayment
            setSelectedPayment("");
        }

        // Update the main payment method state
        setSelectedPaymentMethod(newSelectedMethod);
        console.log("✅ Will set selectedPaymentMethod to:", newSelectedMethod);
    };





    const [applied, setApplied] = useState(() => {
        return localStorage.getItem("appliedCoupon") ? true : false;
    });

    // const coupon = location.state?.coupon; // Retrieve coupon data
    const coupon = routeLocation.state?.coupon || JSON.parse(localStorage.getItem("couponData")) || null;





    useEffect(() => {
        fetch("https://backend.maamaas.com/food/coupon/coupon/1") // Replace with your GET API URL
            .then((response) => response.json())
            .then((data) => setCoupons(data))
            .catch((error) => console.error("Error fetching coupons:", error));
    }, []);

    // Fetch Coupon by ID



    // console.log("Location State:", location.state); // 🔍 Debugging
    // const navigate = useNavigate();
    useEffect(() => {
        const userId = Number(localStorage.getItem("userId"));

        if (!userId) {
            console.error("❌ User ID not found. User might not be logged in.");
            return;
        }

        // Fetching available balance  
        axios
            .get(`https://backend.maamaas.com/food/wallet/getwallet/${userId}`)
            .then((response) => {
                console.log("✅ Full Balance Response:", response.data);
                const data = response.data;

                setAvailableBalance(data.balance || 0);
                setAvailableCompany(data.companyCreditedAmount || 0);
                setAvailableSelf(data.selfCreditedAmount || 0);
                setAvailableCashback(data.cashbacks || 0);
            })
            .catch((error) => {
                console.error("❌ Balance API Error:", error);
                setAvailableBalance(0);
                setAvailableCompany(0);
                setAvailableSelf(0);
                setAvailableCashback(0);
            });

    }, []);





    useEffect(() => {
        // console.log("Updated displayData:", filteredDataProp);
        setDisplayData(filteredDataProp);
    }, [filteredDataProp]);




    useEffect(() => {
        const updateData = () => {
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            if (filteredDataProp && Array.isArray(filteredDataProp) && filteredDataProp.length > 0) {
                setFilteredData(filteredDataProp);

                // Save only if not already stored (prevent quota issues)
                const currentStored = localStorage.getItem("cartItems");
                const newData = JSON.stringify(filteredDataProp);

                if (currentStored !== newData) {
                    try {
                        localStorage.setItem("cartItems", newData);
                    } catch (e) {
                        console.warn("🛑 Storage quota exceeded, not saving cartItems.");
                    }
                }
            }
        };

        updateData();

        const interval = setInterval(() => {
            setRefresh(prev => prev + 1);
            updateData();
        }, 1000); // ⬆ increased to 1000ms to avoid flooding

        return () => clearInterval(interval);
    }, [filteredDataProp, refresh]);






    const handleCategoryClick = (category) => {
        setActiveCategory(category);
    };

    useEffect(() => {
        const fetchCartData = async () => {
            const userId = localStorage.getItem("userId");
            const vendorId = localStorage.getItem("vendorId");
            const seatingId = localStorage.getItem("seatingId"); // ✅ get stored cartId
            const token = localStorage.getItem("authToken");

            if (!userId || !vendorId || !cartId) {
                console.error("🚨 userId, vendorId, or cartId is missing!");
                return;
            }

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`,
                    {
                        headers: token ? { Authorization: `Bearer ${token}` } : {},
                    }
                );

                const cartData = response.data;
                if (!cartData) return;

                // ✅ Store cartId (optional, if needed again)
                if (cartData.cartId) {
                    localStorage.setItem("cartId", cartData.cartId);
                }

                const cartItems = cartData.cartItems || [];
                setCartData(cartItems);
                setFilteredItems(cartItems);

                // Load quantities from API OR localStorage fallback
                const savedQuantities = JSON.parse(localStorage.getItem("cartQuantities") || "{}");
                const updatedQuantities = {};
                cartItems.forEach((item) => {
                    const dishId = item.itemId || item.dishId || item.id;
                    updatedQuantities[dishId] = item.quantity ?? item.qty ?? savedQuantities[dishId] ?? 1;
                });
                setQuantities(updatedQuantities);

                // Persist quantities in localStorage
                localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));

                // Get categories
                const categories = [...new Set(cartItems.map((item) => item.dishName))];
                setAllCategories(["Allcarts", ...categories]);

            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
            }
        };

        fetchCartData();
    }, []);






    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };



    const originalPackingCharge = billingData.packingCharges || 0;

    const [packingCharges, setPackingCharges] = useState(originalPackingCharge);



    const originalDiscounts = billingData.discount || 0; // 1. define original

    const [discounts, setDiscounts] = useState(originalDiscounts); // 2. define state






    useEffect(() => {
        const storedOrderData = localStorage.getItem("orderData");
        const storedShowCheckout = localStorage.getItem("showCheckout");

        if (storedOrderData && storedShowCheckout === "true") {
            setOrderData(JSON.parse(storedOrderData));
            // setShowCheckout(true);

            // ✅ Clear `showCheckout` after showing it once
            localStorage.removeItem("showCheckout");
        }
    }, []);



    cartItems.reduce((acc, item) => ({ ...acc, [item.dishId]: item.quantity || 1 }), {})


    const incrementQuantity = async (item) => {
        const cartId = item?.cartId || localStorage.getItem("cartId");
        const itemId = item?.itemId;
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!cartId || !itemId || !vendorId) {
            console.error("❌ Missing required IDs", { cartId, itemId, vendorId, item });
            return;
        }

        const currentQty = quantities[itemId] || item.quantity || 1;
        const newQuantity = currentQty + 1;

        // ✅ Match cURL
        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?itemId=${itemId}&quantity=${newQuantity}`;
        console.log("📤 incrementQuantity PUT URL:", apiUrl);

        try {
            const response = await axios.put(apiUrl, null, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                    accept: "*/*",
                },
            });

            if (response.status === 200 || response.status === 201) {
                setQuantities((prev) => {
                    const updated = { ...prev, [itemId]: newQuantity };
                    localStorage.setItem("cartQuantities", JSON.stringify(updated));
                    return updated;
                });

                if (typeof loadCart === "function") await loadCart();
                else if (typeof refreshData === "function") await refreshData();

                console.log(`✅ Quantity increased for item ${itemId}: ${newQuantity}`);
            } else {
                console.error("❌ Backend failed:", response.data);
            }
        } catch (err) {
            console.error("❌ Error updating quantity:", err.response?.data || err.message);
        }
    };



    useEffect(() => {
        setDisplayData(cartItems);
    }, [cartItems]);

    useEffect(() => {
        loadCart();

        const savedQuantities = localStorage.getItem("cartQuantities");
        if (savedQuantities) {
            setQuantities(JSON.parse(savedQuantities));
        }
    }, []);

    // ✅ This runs once to load initial cart
    const loadCart = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const seatingId = localStorage.getItem("seatingId"); // ✅ fetch seatingId
        const authToken = localStorage.getItem("authToken"); // ✅ fetch token

        if (!vendorId) {
            console.error("🚨 Vendor ID not found in localStorage!");
            setCartItems([]); // reset if no vendor
            return;
        }

        if (!authToken) {
            console.error("🚨 Auth Token not found in localStorage!");
            setCartItems([]); // reset if no token
            return;
        }

        if (!seatingId) {
            console.error("🚨 Seating ID not found in localStorage!");
            setCartItems([]); // reset if no seatingId
            return;
        }

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`, // ✅ attach token
                        "Cache-Control": "no-cache",
                    },
                }
            );

            const data = response.data || {};
            const items = data.cartItems || [];

            // ✅ Update items
            setCartItems(items);

            // ✅ Rebuild quantities fresh from API
            const updatedQuantities = items.reduce((acc, item) => {
                const dishId = item.dishId || item.itemId || item.id;
                acc[dishId] = item.quantity ?? item.qty ?? 1;
                return acc;
            }, {});
            setQuantities(updatedQuantities);

            // ✅ Persist only after fresh update
            localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));

            // ✅ Save cartId for future calls
            if (data.cartId) {
                localStorage.setItem("cartId", data.cartId);
            }

            // ✅ Update totals & charges
            setSubTotal(data.subtotal || 0);
            setgstTotal(data.gstTotal || 0);
            setserviceCharges(data.serviceCharges || 0);
            setPlatformCharge(data.platformCharges || 0);
            setGrandTotal(data.grandTotal || 0);
            setCgst((data.gstTotal || 0) / 2);
            setSgst((data.gstTotal || 0) / 2);
            settableCode(data.tableCode || "");

            console.log("🛒 Cart refreshed successfully:", items);
        } catch (error) {
            console.error("❌ Error fetching cart data:", error);
            setCartItems([]); // fallback to empty cart
        }
    };

    const decrementQuantity = async (item) => {
        const cartId = item?.cartId || localStorage.getItem("cartId");
        const itemId = item?.itemId;
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!cartId || !itemId || !vendorId) {
            console.error("❌ Missing required IDs", { cartId, itemId, vendorId, item });
            return;
        }

        const currentQty = quantities[itemId] || item.quantity || 1;
        const newQuantity = currentQty - 1;

        if (newQuantity < 0) return; // 👈 don't go below 0

        const updateUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?itemId=${itemId}&quantity=${newQuantity}`;

        try {
            const response = await axios.put(updateUrl, {}, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200 || response.status === 201) {
                setQuantities((prev) => {
                    const updated = { ...prev, [itemId]: newQuantity };
                    localStorage.setItem("cartQuantities", JSON.stringify(updated));
                    return updated;
                });

                if (typeof loadCart === "function") await loadCart();
                else if (typeof refreshData === "function") await refreshData();

                console.log(`✅ Quantity updated for item ${itemId}: ${newQuantity}`);
            } else {
                console.error("❌ Backend failed:", response.data);
            }
        } catch (err) {
            console.error("❌ Error updating quantity:", err.response?.data || err.message);
        }
    };


    // Refresh can just call loadCart again
    const refreshData = async () => {
        await loadCart();
    };




    // Decrement Function



    useEffect(() => {
        let isMounted = true;

        const vendorId = localStorage.getItem("vendorId") || "1";
        const token = localStorage.getItem("authToken");
        const seatingId = localStorage.getItem("seatingId");
        fetch(`https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (isMounted) {
                    console.log("Fetched Data:", data);
                    localStorage.setItem("cartItems", JSON.stringify(data)); // Store in localStorage
                    setItems(Array.isArray(data) ? data : []);
                }
            })
            .catch((error) => console.error("Error fetching data:", error));

        return () => {
            isMounted = false;
        };
    }, []);

    const handleClearCart = async (cartId) => {
        try {
            const vendorId = localStorage.getItem("vendorId");
            const authToken = localStorage.getItem("authToken");

            if (!vendorId) {
                alert("Vendor ID not found!");
                return;
            }

            if (!cartId) {
                alert("Cart ID not found!");
                return;
            }

            if (!authToken) {
                alert("Authentication token not found!");
                return;
            }

            const response = await fetch(
                `https://backend.maamaas.com/food/api/cart/delete/${vendorId}/${cartId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${authToken}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            alert("🗑️ Cart cleared successfully!");
            setDisplayData([]); // ✅ Clear table data in UI

        } catch (error) {
            console.error("Failed to clear cart:", error);
            alert("Failed to clear the cart. Please try again!");
        }
    };









    const handleShowGST = async (vendorId) => {
        // fallback to localStorage if nothing is passed
        const currentVendorId = vendorId || localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/${currentVendorId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // if required
                    },
                }
            );

            const data = response.data;
            console.log("Fetched GST Data (Raw Response):", data);

            // ✅ Handle both array and object response cases
            const gstObj = Array.isArray(data) ? data[0] : data;

            if (gstObj) {
                const gstDetails = {
                    serviceChargeGst: gstObj.serviceChargeGst ?? 0,
                    platformChargeGst: gstObj.platformChargeGst ?? 0,
                    cgst: gstObj.cgst ?? 0,
                    sgst: gstObj.sgst ?? 0,
                    gstTotal: gstObj.gstTotal ?? 0,   // 👈 added total if you want to show
                    grandTotal: gstObj.grandTotal ?? 0,
                };

                console.log("Extracted GST & Billing Details:", gstDetails);
                console.table(gstDetails);

                setGstData(gstDetails);
                setShowPopup(true);
            } else {
                console.warn("No GST data found in API response.");
            }
        } catch (err) {
            console.error("Error fetching GST data:", err);
        }
    };

    const [offers, setOffers] = useState([]);

    // Fetching data with parentId === 0
    useEffect(() => {
        const fetchCartData = async () => {
            const userId = localStorage.getItem("userId");
            const vendorId = localStorage.getItem("vendorId");
            const seatingId = localStorage.getItem("seatingId"); // ✅ get stored cartId
            const token = localStorage.getItem("authToken");

            if (!userId || !vendorId || !cartId) {
                console.error("🚨 userId, vendorId, or cartId is missing!");
                return;
            }

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`,
                    {
                        headers: token ? { Authorization: `Bearer ${token}` } : {},
                    }
                );

                const cartData = response.data;
                if (!cartData) return;

                // ✅ Store cartId (optional, if needed again)
                if (cartData.cartId) {
                    localStorage.setItem("cartId", cartData.cartId);
                }

                const cartItems = cartData.cartItems || [];
                setCartData(cartItems);
                setFilteredItems(cartItems);

                // Load quantities from API OR localStorage fallback
                const savedQuantities = JSON.parse(localStorage.getItem("cartQuantities") || "{}");
                const updatedQuantities = {};
                cartItems.forEach((item) => {
                    const dishId = item.itemId || item.dishId || item.id;
                    updatedQuantities[dishId] = item.quantity ?? item.qty ?? savedQuantities[dishId] ?? 1;
                });
                setQuantities(updatedQuantities);

                // Persist quantities in localStorage
                localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));

                // Get categories
                const categories = [...new Set(cartItems.map((item) => item.dishName))];
                setAllCategories(["Allcarts", ...categories]);

            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
            }
        };

        fetchCartData();
    }, []);







    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    // Empty dependency array ensures this runs once when the component mounts

    const buttonStyle = {
        margin: '10px',
        padding: '10px 20px',
        fontWeight: "bold",
        fontSize: "20px",
        backgroundColor: 'rgb(177 93 198)',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        // width: "150px"
    };


    return (
        <div>

            {/* <p className="breadcrumb" style={{ marginTop: "-23px", fontSize: "22px", marginLeft: "0px", marginBottom: "-12px" }}>
                <Link to="/home" style={{ color: "#757171", textDecoration: "none" }}>Home</Link><span className="separator"> &gt; </span><Link to="/food" style={{ color: "#757171", textDecoration: "none" }}>Food</Link> <span className="separator"> &gt; </span><Link to="/maamaas" style={{ color: "#757171", textDecoration: "none" }}>Maamaas</Link><span className="separator"> &gt; </span> <span style={{ color: "#b15dc6" }}>Cart</span>
            </p> */}
            {!showPaymentData ? (

                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    {/* Button Section */}

                    {/* ===================  check Out code ============================================== */}
                    <div
                        style={{
                            overflowY: isMobile ? "none" : "auto",
                            scrollbarWidth: "none",
                            marginTop: "-50px",
                            height: containerHeight,
                            overflow: "auto",
                        }}
                        className="carts1 "
                    >



                        <>

                            <div>
                                <>
                                    <style>{`
        .order-wrapper {
          display: flex;
          flex-direction: column;
        //   padding: 5px;
           background: #b15cd6;
          font-family: sans-serif;
         border-radius: 10px;
         margin-top:10px;
        }

        .order-container {
          background: #b15cd6;
          border-radius: 10px;
          color: #fff;
          padding: 15px;
          margin-bottom: 20px;
        }

        .order-heading {
          font-weight: bold;
          text-align: center;
          font-size: 22px;
          margin-bottom: 15px;
        }

        .order-table-wrapper {
          overflow-x: auto;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 15px;
          font-weight: bold;
        }

        th, td {
          padding: 10px;
          border-bottom: 1px solid #fff;
          text-align: center;
          font-size: 18px;
        }


@media (max-width: 480px) {
  th, td {
    font-size: 8px;
  }
}


        .quantity-box {
          display: flex;
          align-items: center;
          background: #fff;
          border-radius: 10px;
          width: 80px;
          margin: auto;
        }

        .quantity-box button {
          border: none;
          background: transparent;
          padding: 5px;
          cursor: pointer;
          color: #000;
          font-weight: bold;
          font-size:16px;
        }

        .quantity-box span {
          padding: 0 10px;
          font-weight: 800;
          color: #000;
        }

        .no-data {
          text-align: center;
          padding: 20px;
          font-weight: bold;
        }

        .total-section {
          background: #b15cd6;
          border-radius: 10px;
          padding: 20px;
          color: white;
        }

        .pricedetails {
          display: flex;
        //   align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        //   flex-wrap: wrap;
        }

        .pricedetails dt,
        .pricedetails dd {
          margin: 0;
          font-size:19px;
        }

        .pricedetails dd {
          min-width: 50px;
          text-align: right;
        }

        .total-button {
          padding: 4px 10px;
          width: 85px;
          height: 35px;
          cursor: pointer;
          border: none;
          border-radius: 10px;
          color: white;
          font-weight: bold;
        }

        hr {
          border: 2px solid #000 !important;
          margin: 15px 0;
        }

        @media (max-width: 1200px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
        }

        @media (max-width: 768px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }

           .clear-cart-data-size{
            font-size: 13px !important;
            }
            .cart-title-data{
            font-size: 20px !important;
            }
                                    }
      `}</style>

                                    <div className="order-wrapper">
                                        {/* Order Items Table */}
                                        <div className="order-container">
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <h4 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>
                                                    Table No: <span style={{ color: "#00b73b" }}>{tableCode || "-"}</span>
                                                </h4>


                                                <h4 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>
                                                    Review your Cart
                                                </h4>

                                                <button
                                                    onClick={() => handleClearCart(localStorage.getItem("cartId"))}
                                                    style={{
                                                        color: "red",
                                                        background: "#fff",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        fontSize: "18px",
                                                        padding: "4px 8px"
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            </div>


                                            <div className="order-table-wrapper">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>S.NO</th>
                                                            <th>ITEM</th>
                                                            <th>QUANTITY</th>
                                                            <th>PRICE</th>
                                                            <th>TOTAL</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {displayData.length > 0 ? (
                                                            displayData
                                                                .filter((item) => (quantities[item.dishId] ?? item.quantity ?? 1) > 0) // 👈 only show items with qty > 0
                                                                .map((item, index) => (
                                                                    <tr
                                                                        key={item.cartItemId}
                                                                        style={{ textAlign: "center", verticalAlign: "middle" }}
                                                                    >
                                                                        <td>{index + 1}</td>
                                                                        <td style={{ fontWeight: "bold" }}>{item.dishName}</td>
                                                                        <td>
                                                                            <div className="quantity-box">
                                                                                <button
                                                                                    className="qty-btn"
                                                                                    onClick={() => decrementQuantity(item)}
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <span className="qty-value">
                                                                                    {quantities[item.dishId] ?? item.quantity ?? 1}
                                                                                </span>
                                                                                <button
                                                                                    className="qty-btn"
                                                                                    onClick={() => incrementQuantity(item)}
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                        <td>₹{item.price?.toFixed(2)}</td>
                                                                        <td>₹{item.totalPrice.toFixed(2)}</td>
                                                                    </tr>
                                                                ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="no-data">
                                                                    No data available
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                        <hr />
                                        {/* Total Pricing Summary */}
                                        <div className="total-section">
                                            <dl>
                                                <div className="pricedetails">
                                                    <dt>Sub Total</dt>
                                                    <dd>₹{subTotal}</dd>
                                                </div>
                                                <div className="pricedetails">
                                                    <dt>Platform Charges</dt>
                                                    <dd>₹{platformCharge}</dd>
                                                </div>
                                                {/* <div className="pricedetails">
                                                    <dt>Service Charges</dt>
                                                    <dd>₹{
                                                        serviceCharges
                                                    }</dd>
                                                </div> */}
                                                <div className="pricedetails">
                                                    <dt
                                                        onClick={() => {
                                                            const cartId = localStorage.getItem("cartId");
                                                            toggleServiceCharges(cartId);
                                                        }}
                                                        style={{
                                                            cursor: "pointer",
                                                            padding: "4px 8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ccc",
                                                            background: "rgb(242, 242, 242)",
                                                            fontWeight: "bold",
                                                            color: "#000",
                                                            fontSize: "15px",
                                                        }}
                                                    >
                                                        Service Charges {serviceApplied ? "(Remove)" : "(Apply)"}
                                                    </dt>



                                                    <dd>₹{serviceCharges}</dd>
                                                </div>
                                                {/* <div className="pricedetails">
                                                    <dt>GST</dt>
                                                    <dd>₹{sgst}</dd>
                                                </div> */}
                                                <div className="pricedetails">
                                                    <dt>GST   <FaInfoCircle
                                                        style={{ marginLeft: "8px", cursor: "pointer", color: "rgb(0 187 90)" }}
                                                        onClick={() => handleShowGST(vendorId)}
                                                    /></dt>
                                                    <dd>₹{gstTotal}</dd>
                                                </div>
                                                <hr />

                                                <div className="pricedetails" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    <dt>Grand Total</dt>
                                                    <dd>₹{grandTotal}</dd>
                                                </div>
                                            </dl>
                                        </div>
                                    </div>
                                </>
                            </div>


                            <div className="row">


                                <div
                                    style={{

                                        background: 'rgb(24, 157, 62)',
                                        borderRadius: '25px',
                                        color: '#fff',

                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}
                                >

                                    {savedDetails && (
                                        <>

                                            {confirmedAddress && selectedOrderType !== "Take Away" && selectedOrderType !== "Dine In" && (
                                                <div
                                                    style={{
                                                        background: 'rgb(177, 93, 198)',
                                                        borderRadius: '10px',
                                                        color: '#fff',
                                                        padding: '20px 30px',
                                                        margin: '10px 0',
                                                        fontFamily: 'Arial, sans-serif'
                                                    }}
                                                >

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: '40px',
                                                            fontSize: "16px",
                                                            justifyContent: 'space-between',
                                                            marginLeft: "100px"
                                                        }}
                                                    >


                                                        <div style={{ flex: 1, minWidth: "250px", display: 'flex', flexDirection: 'column', gap: '10px' }}>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Location</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{addressDetails?.categoree || "N/A"}</div>
                                                            </div>


                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Address Line</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.addressLine}</div>
                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Pincode</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.pincode}</div>
                                                            </div>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Date</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{savedDetails?.date ? new Date(savedDetails.date).toLocaleDateString("en-GB") : "N/A"}</div>
                                                            </div>
                                                        </div>

                                                        {/* Right Column */}
                                                        <div style={{ flex: 1, minWidth: "250px", display: 'flex', flexDirection: 'column', gap: '10px', marginLeft: "50px" }}>


                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Landmark</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.landMark}</div>
                                                            </div>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>City</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.city}</div>
                                                            </div>

                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>State</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{confirmedAddress?.state}</div>
                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ width: "130px", fontWeight: "bold" }}>Time</div>
                                                                <div style={{ margin: "0 10px" }}>:</div>
                                                                <div>{savedDetails?.time ?? "N/A"}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        </>
                                    )}

                                </div>

                            </div>


                            {/* Internal CSS */}
                            <style>{`
        .payment-container {
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }

        .primary-btn {
            padding: 10px 20px;
            background-color: #b15dc6;
            color: #fff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            width: 150px;
            font-weight: bold;
            font-size: 20px;
        }

        .payment-options {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 30px;
        }

        .payment-options button {
            padding: 10px 20px;
            border: none;
            border-radius: 5px;
            width: 140px;
            font-weight: bold;
            font-size: 20px;
            cursor: pointer;
        }

        .pay-now {
            background-color: #4CAF50;
            color: #fff;
        }

        .pay-later {
            background-color: #f44336;
            color: #fff;
        }

        .method-box-container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 20px;
            margin-top: 40px;
        }

        .method-box {
            flex: 1;
            min-width: 250px;
            max-width: 30%;
            
            background: rgb(177, 93, 198);
            border-radius: 10px;
            display: flex;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
        }

        .method-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .method-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-balance-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-container {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #b15cd6;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: 10px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        /* Responsive for smaller screens */
        @media (max-width: 768px) {
            .method-box {
                max-width: 100%;
            }

            .payment-options {
                flex-direction: column;
                align-items: center;
                gap: 15px;
            }
        }
            @media (max-width: 768px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
           
        }
    `}</style>




                            {selectedOrderType === "Dine In" && (
                                <div className="row">
                                    <div className="col-12">
                                        {/* Place Order Button */}
                                        <div ref={paymentRef} className="payment-options">
                                            <button className="pay-now" onClick={() => handlePaymentClick("payNow")}>Pay Now</button>
                                            <button className="pay-later" onClick={() => handlePaymentClicks("payLater")}>Pay Later</button>
                                        </div>

                                        {/* Pay Now / Later */}
                                        {isPaymentOptionsVisible && (
                                            <div ref={walletSectionRef}>
                                                <div className="method-box-container">
                                                    {/* Wallet Box */}
                                                    <div className="method-box">
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => handleCheckboxChange(e, "wallet")}
                                                        />
                                                        <h3>Walletsss</h3>
                                                        <button className="wallet-balance-btn">₹{availableBalance.toFixed(2)}</button>
                                                    </div>

                                                    {/* Cash Box */}
                                                    <div className="method-box">
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => handleCheckboxChange(e, "cash")}
                                                            checked={isCashChecked}
                                                        />
                                                        <h3>Cash</h3>
                                                    </div>

                                                    {/* Online Payment Box */}
                                                    <div className="method-box">
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => handleCheckboxChange(e, "online")}
                                                        />
                                                        <h3>Online Payment</h3>
                                                    </div>
                                                </div>

                                                {/* Checkout Button */}


                                                {/* Payment Data Display */}
                                                {showPaymentData && selectedService === "Dine In" && orderData && (
                                                    <Paymentdata
                                                        applied={applied}
                                                        coupon={coupon}
                                                        isApplieds={isApplieds}
                                                        orderData={orderData}
                                                    />
                                                )}

                                            </div>
                                        )}

                                        {/* Payment Method Options */}

                                    </div>
                                </div>
                            )}


                        </>


                        <style>{`
       

        .payment-box {
            flex: 1;
            min-width: 250px;
            max-width: 30%;
            height: 60px;
            background: rgb(177, 93, 198);
            border-radius: 10px;
            display: flex;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
        }

        .payment-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .payment-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-amount-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-wrapper {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #b15cd6;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: -30px;
            margin-bottom: 20px;
            padding: 0 30px;
        }
              @media (min-width: 768px) {
 .payment-row {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-top: 40px;
            flex-wrap: wrap;
        }
                        }
        @media (max-width: 768px) {
            .payment-box {
                max-width: 100%;
            }
                .payment-row {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-top: -20px !important;
            flex-wrap: wrap;
        }

        }
    `}</style>


                        {selectedOrderType !== "Dine In" && (
                            <div className="payment-row">
                                {/* Wallet */}

                                {/* Cash */}
                                <div className="payment-box">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => handleCheckboxChange(e, "cash")}
                                        checked={isCashChecked}
                                    />
                                    <h3>Cash</h3>
                                </div>


                                <div className="payment-box">
                                    <div className="payment-box">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => handleCheckboxChange(e, "online", "online")}
                                            checked={selectedPayment === "online"}
                                        />
                                        <h3>Online Payment</h3>
                                    </div>

                                    {/* Conditionally render phone number input */}
                                    {selectedPayment === "online" && (
                                        <div
                                            className="phone-input-box"
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                margin: "10px 0",
                                            }}
                                        >
                                            <input
                                                type="text"
                                                id="phoneNumber"
                                                name="phoneNumber"
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                placeholder="Enter phone number"
                                                style={{
                                                    width: "250px",
                                                    padding: "10px 15px",
                                                    borderRadius: "8px",
                                                    border: "1px solid #ccc",
                                                    outline: "none",
                                                    fontSize: "16px",
                                                    transition: "0.3s",
                                                }}
                                                onFocus={(e) => (e.target.style.borderColor = "#b15cd6")}
                                                onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                                            />
                                        </div>

                                    )}
                                </div>

                            </div>
                        )}
                        <div className="checkout-wrapper" style={{ marginTop: "50px" }}>
                            <button className="checkout-btn" onClick={handleCheckoutClickS}>
                                Procced to CheckOut
                            </button>
                        </div>

                    </div >






                    {/* ===================================== GST POP UP DATA =============================================================== */}


                    {showPopup && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: "rgba(0, 0, 0, 0.6)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 999,
                                animation: "fadeIn 0.3s ease-in-out",
                            }}
                        >
                            <div
                                style={{
                                    background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                                    padding: "25px",
                                    borderRadius: "12px",
                                    width: "350px",
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                                    textAlign: "center",
                                    animation: "scaleUp 0.3s ease-in-out",
                                }}
                            >
                                <h3 style={{ marginBottom: "15px", color: "#333", fontSize: "20px" }}>
                                    GST Breakdown
                                </h3>

                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Service Charge GST:</strong> ₹{gstData.serviceChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Platform Charge GST:</strong> ₹{gstData.platformChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>CGST:</strong> ₹{gstData.cgst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>SGST:</strong> ₹{gstData.
                                            sgst
                                        }
                                    </li>
                                </ul>

                                <button
                                    onClick={() => setShowPopup(false)}
                                    style={{
                                        marginTop: "20px",
                                        padding: "10px 18px",
                                        background: "linear-gradient(90deg, #007bff, #0056d2)",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                    }}
                                    onMouseOver={(e) =>
                                    (e.target.style.background =
                                        "linear-gradient(90deg, #0056d2, #003c99)")
                                    }
                                    onMouseOut={(e) =>
                                    (e.target.style.background =
                                        "linear-gradient(90deg, #007bff, #0056d2)")
                                    }
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div >
            ) : (
                <Paymentdata />
            )
            }

        </div >

    );
};

export default Cartwaiter;










